import { create as createStore } from "zustand"
import { persist } from "zustand/middleware"

export type PreferredConsoleMode = "classic" | "dashboard"

interface PreferredConsoleModeState {
  preferredConsoleMode: PreferredConsoleMode | null
  setPreferredConsoleMode: (mode: PreferredConsoleMode | null) => void
}

export const usePreferredConsoleModeStore = createStore(
  persist<PreferredConsoleModeState>(
    (set, get) => ({
      preferredConsoleMode: null,
      setPreferredConsoleMode: (mode) => {
        if (get().preferredConsoleMode === mode) return
        set({ preferredConsoleMode: mode })
      },
    }),
    {
      name: "preferred-console-mode-state",
    }
  )
)
